import { useMutation, UseMutationResult } from "@tanstack/react-query";
import {
	AuthTokenResponse,
	uploadSelfie,
	UploadSelfieParams,
} from "@/api/face-auth.ts";
import { RequestError } from "@/axios/schema.ts";

const useFaceAuth = (): UseMutationResult<
	AuthTokenResponse,
	RequestError,
	UploadSelfieParams
> => {
	return useMutation({
		mutationFn: async ({ imageBlob }: UploadSelfieParams) => {
			return uploadSelfie({ imageBlob });
		},
	});
};

export default useFaceAuth;
